import { render } from "./PageDersNotlari.vue?vue&type=template&id=2f187b12&scoped=true"
import script from "./PageDersNotlari.vue?vue&type=script&lang=js"
export * from "./PageDersNotlari.vue?vue&type=script&lang=js"

import "./PageDersNotlari.vue?vue&type=style&index=0&id=2f187b12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f187b12"

export default script